"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iterable = void 0;
var guard_1 = require("../guard");
var helpers_1 = require("../utils/helpers");
/**
 * Constructs a type-guard for an `Iterable` type
 * @param items type-guard for an item of the iterable
 */
function iterable(items) {
    if (items instanceof guard_1.TypeGuard === false) {
        throw new Error('"items" must an instance of Guard');
    }
    var schema = Object.freeze({
        type: 'object',
        trait: 'iterable',
        items: items.schema
    });
    return new guard_1.TypeGuard(schema, function (value) {
        if (typeof value === 'object' &&
            value !== null &&
            typeof value[Symbol.iterator] === 'function') {
            var result = helpers_1.mapIterable(value, items.coerce);
            if (Array.isArray(value)) {
                return __spread(result);
            }
            else if (value instanceof Set) {
                try {
                    return new Set(result);
                }
                catch (_a) {
                    return value;
                }
            }
            else if (value instanceof Map) {
                try {
                    return new Map(result);
                }
                catch (_b) {
                    return value;
                }
            }
            else {
                return result;
            }
        }
        return value;
    }, function (value) {
        var index, _a, _b, v, _c, _d, _e, path, rest, e_1_1, e_2_1;
        var e_2, _f, e_1, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    if (!(typeof value === 'object' &&
                        value !== null &&
                        typeof value[Symbol.iterator] === 'function')) return [3 /*break*/, 16];
                    index = 0;
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 13, 14, 15]);
                    _a = __values(value), _b = _a.next();
                    _h.label = 2;
                case 2:
                    if (!!_b.done) return [3 /*break*/, 12];
                    v = _b.value;
                    _h.label = 3;
                case 3:
                    _h.trys.push([3, 8, 9, 10]);
                    _c = (e_1 = void 0, __values(items.validate(v))), _d = _c.next();
                    _h.label = 4;
                case 4:
                    if (!!_d.done) return [3 /*break*/, 7];
                    _e = _d.value;
                    path = _e.path, rest = __rest(_e, ["path"]);
                    return [4 /*yield*/, __assign({ path: __spread([index], path) }, rest)];
                case 5:
                    _h.sent();
                    _h.label = 6;
                case 6:
                    _d = _c.next();
                    return [3 /*break*/, 4];
                case 7: return [3 /*break*/, 10];
                case 8:
                    e_1_1 = _h.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 10];
                case 9:
                    try {
                        if (_d && !_d.done && (_g = _c.return)) _g.call(_c);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 10:
                    index++;
                    _h.label = 11;
                case 11:
                    _b = _a.next();
                    return [3 /*break*/, 2];
                case 12: return [3 /*break*/, 15];
                case 13:
                    e_2_1 = _h.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 15];
                case 14:
                    try {
                        if (_b && !_b.done && (_f = _a.return)) _f.call(_a);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 15: return [3 /*break*/, 18];
                case 16: return [4 /*yield*/, {
                        path: [],
                        rule: 'type',
                        setting: 'iterable',
                        actual: helpers_1.actualTypeOf(value)
                    }];
                case 17:
                    _h.sent();
                    _h.label = 18;
                case 18: return [2 /*return*/];
            }
        });
    });
}
exports.iterable = iterable;
